import {idFromGlobalId} from './GlobalIdUtil';

export type profile = {
	id: string;
	name: string;
	disable: boolean;
};

export function getAssignableProfiles(profiles: profile[]): profile[] {
	return profiles.filter(
		profile => idFromGlobalId(profile.id) !== -2 && idFromGlobalId(profile.id) !== -3 && !profile.disable
	);
}
